// import React from 'react'
import { createMuiTheme } from '@material-ui/core/styles'
const theme = createMuiTheme({
  palette: {
    primary: { main: '#ffccbc', contrastText: '#666565' },
    secondary: { main: '#fbe9e7', contrastText: '#F5F5F5' }
    // background: { default: '#FFFFFF', paper: 'FFFFFF' }
  }
})
export default theme
